import React, {useEffect, useState} from 'react'
import {useSelector, useDispatch} from 'react-redux'
import * as Member from '../../store/ducks/member.duck'
import {useNavigate, Link as RouterLink} from 'react-router-dom'
import PolicyCard, {CardInfoDisplay} from '../../../../src/app/components/Cards/PolicyCard'
import {DependentsTileGrid} from '../../components/Cards/DependentsDisplay'
import RequestsCard from '../../../../src/app/components/Cards/RequestsCard'
import CardBlueLink from '../../../../src/app/components/Cards/CardBlueLink'
import DonationPreviewCard from '../../components/Cards/DonationPreview'
import PlanCard from '../../components/Cards/PlanCard'
import DashboardSection from '../../components/Cards/DashboardSection'
import DashboardBox from '../../components/DashboardBox'
import CloseIcon from '@mui/icons-material/Close'
import {Button, IconButton, Typography, Alert, AlertTitle, Box} from '@mui/material'
import Link from '@mui/material/Link'

export default function Dashboard() {
  const dashboardTitle = 'Health Policy Information'
  const dispatch = useDispatch()
  let navigate = useNavigate()
  //
  const bannerdisplay = useSelector((state) => state.auth.bannerDisplay)
  const showDependentsMissingSsnWarning = useSelector((state) => state.auth.activeDependentsMissingSsnCount)
  const dependentsMissingSsnWarning = useSelector((state) => state.member.dependentsMissingSsnWarning)
  // 1/5 Note the splash is no longer displaying the survey 2025 as AFSPA only want it to display twice
  // const splashDisplay = useSelector((state) => state.auth.splashDisplay)
  const accreditation = useSelector((state) => state.member.Flags.AccreditationDisplay)
  // const upcomingMaintenanceDisplay = useSelector((state) => state.member.Flags.UpcomingMaintenanceDisplay)
  //const upcomingMaintenanceMessage = useSelector((state) => state.member.Flags.UpcomingMaintenanceMessage)
  const [upcomingMaintenanceDisplay, setUpcomingMaintenanceDisplay] = useState(false)
  const outageDisplay = useSelector((state) => state.member.Flags.OutageDisplay)
  const planInformation = useSelector((state) => state.member.PlanInformation)
  const [showIssue, setShowIssue] = useState(false)
  const [showCreditCardIssue, setShowCreditCardIssue] = useState(false)
  const [accordionOpen, setAccordionOpen] = useState(false)
  // const surveyDisplay = false

  // FSBP Plan Information
  const FSBP = useSelector((state) => state.member.FSBP)
  const Health = useSelector((state) => state.auth.health)
  const Dependents = useSelector((state) => state.member.Dependents)
  const allowClaims = useSelector((state) => state.auth.allowClaims)
  // Immediate Benefit Plan Information
  const IBP = useSelector((state) => state.member.IBP)
  const IBPPrimaryBeneficiaries =
    IBP && IBP.Secondary && IBP.Secondary['Primary Beneficiary 1'] && IBP.Secondary['Primary Beneficiary 1'].length > 0
      ? {
          ['Primary Beneficiaries']: '',
          ['Primary Beneficiary 1']: IBP.Secondary['Primary Beneficiary 1'],
          ['Primary Beneficiary 2']: IBP.Secondary && IBP.Secondary['Primary Beneficiary 2'] && IBP.Secondary['Primary Beneficiary 2'].length > 0 ? IBP.Secondary['Primary Beneficiary 2'] : '',
          ['Primary Beneficiary 3']: IBP.Secondary && IBP.Secondary['Primary Beneficiary 3'] && IBP.Secondary['Primary Beneficiary 3'].length > 0 ? IBP.Secondary['Primary Beneficiary 3'] : ''
        }
      : ''
  const IBPContingentBeneficiaries =
    IBP && IBP.Secondary && IBP.Secondary['Contingent Beneficiary 1'] && IBP.Secondary['Contingent Beneficiary 1'].length > 0
      ? {
          ['Contingent Beneficiaries']: '',
          ['Contingent Beneficiary 1']: IBP.Secondary['Contingent Beneficiary 1'],
          ['Contingent Beneficiary 2']:
            IBP.Secondary && IBP.Secondary['Contingent Beneficiary 2'] && IBP.Secondary['Contingent Beneficiary 2'].length > 0 ? IBP.Secondary['Contingent Beneficiary 2'] : ''
        }
      : ''
  const IBPOtherBeneficiaries =
    IBP && IBP.Secondary && IBP.Secondary['Other Beneficiary 1'] && IBP.Secondary['Other Beneficiary 1'].length > 0
      ? {
          ['Other Beneficiaries']: '',
          ['Other Beneficiary 1']: IBP.Secondary['Other Beneficiary 1'],
          ['Other Beneficiary 2']: IBP.Secondary && IBP.Secondary['Other Beneficiary 2'] && IBP.Secondary['Other Beneficiary 2'].length > 0 ? IBP.Secondary['Other Beneficiary 2'] : ''
        }
      : ''
  const IBPSecondary = {...IBPPrimaryBeneficiaries, ...IBPContingentBeneficiaries, ...IBPOtherBeneficiaries}
  // Disability Plan Information
  const Disability = useSelector((state) => state.member.Disability)
  // Dental Plan Information
  const Dental = useSelector((state) => state.member.Dental)
  // Handle the Different Dental Plans
  const DentalPlanID = Dental.Primary && Dental.Primary['Plan Name'] && Dental.Primary['Plan Name'] ? 'DENTAL-' + Dental.Primary['Plan Name'].replaceAll(' ', '').toUpperCase() : 'DENTAL'
  // GEL Plan Information
  const Gel = useSelector((state) => state.member.Gel)
  // Senior Life Plan Information
  const SeniorLife = useSelector((state) => state.member.SeniorLife)
  // CI Plan Information
  const CI = useSelector((state) => state.member.CI)
  // ADND Plan Information
  const ADND = useSelector((state) => state.member.Adnd)
  // New Life Plan Information
  const NewLife = useSelector((state) => state.member.NewLife)
  // Long Term Care Plan Information
  const Ltc = useSelector((state) => state.member.Ltc)
  // SLF Information
  const SLF = useSelector((state) => state.member.SLF)
  //
  useEffect(() => {
    dispatch(Member.actions.fetchPlanInformation())
  }, [dispatch])
  useEffect(() => {
    dispatch(Member.actions.fetchGel())
  }, [dispatch])
  useEffect(() => {
    dispatch(Member.actions.fetchNewLife())
  }, [dispatch])
  useEffect(() => {
    dispatch(Member.actions.fetchSeniorLife())
  }, [dispatch])
  useEffect(() => {
    dispatch(Member.actions.fetchLtc())
  }, [dispatch])
  useEffect(() => {
    dispatch(Member.actions.fetchFSBP())
  }, [dispatch])
  useEffect(() => {
    dispatch(Member.actions.fetchDependents())
  }, [dispatch])
  useEffect(() => {
    dispatch(Member.actions.fetchIBP())
  }, [dispatch])
  useEffect(() => {
    dispatch(Member.actions.fetchDisability())
  }, [dispatch])
  useEffect(() => {
    dispatch(Member.actions.fetchDental())
  }, [dispatch])
  useEffect(() => {
    dispatch(Member.actions.fetchCI())
  }, [dispatch])
  useEffect(() => {
    dispatch(Member.actions.fetchAdnd())
  }, [dispatch])
  useEffect(() => {
    dispatch(Member.actions.fetchFlags({bypassToken: null}))
  }, [dispatch])
  useEffect(() => {
    dispatch(Member.actions.fetchSLF())
  }, [dispatch])
  return (
    <DashboardBox>
      <DashboardSection name={Health ? dashboardTitle : null}>
        <React.Fragment>
          {upcomingMaintenanceDisplay && !outageDisplay ? (
            <Box sx={{width: '100%', my: 1}}>
              <Alert
                severity='warning'
                sx={{
                  py: 3,
                  px: 3,
                  borderRadius: 2,
                  boxShadow: 2,
                  backgroundColor: '#fff8e1',
                  border: '1px solid #ffe082'
                }}
                action={
                  <IconButton aria-label='close' color='inherit' size='small' onClick={() => setUpcomingMaintenanceDisplay(false)}>
                    <CloseIcon fontSize='inherit' />
                  </IconButton>
                }
              >
                <Box sx={{width: '100%', mx: 'auto'}}>
                  <Box
                    component='p'
                    sx={{
                      fontSize: '1rem',
                      lineHeight: 1.0,
                      m: 0
                    }}
                  >
                    <AlertTitle sx={{fontSize: '1.1rem', fontWeight: 'bold'}}>Maintenance Notice:</AlertTitle>
                    The system will be undergoing maintenance on Tuesday, 7/28/2026 from 9:30pm to 10pm EST. We apologize for any inconvenience.
                  </Box>
                </Box>
              </Alert>
            </Box>
          ) : null}
          {showIssue && (
            <Box sx={{width: '100%', py: 1}}>
              <Alert
                severity='warning'
                action={
                  <IconButton aria-label='close' color='inherit' size='small' onClick={() => setShowIssue(false)}>
                    <CloseIcon fontSize='inherit' />
                  </IconButton>
                }
                sx={{
                  width: '100%',
                  alignItems: 'flex-start',
                  mx: 'auto',
                  maxWidth: '100%',
                  fontSize: '1rem'
                }}
              >
                <Box sx={{width: '100%'}} className='experience-issues-text'>
                  <AlertTitle sx={{fontSize: '1.1rem', fontWeight: 'bold'}}>Note the Claim Submission process has been updated with new categories and options.</AlertTitle>

                  {/* Custom clickable toggle instead of AccordionSummary */}
                  <Button
                    onClick={() => setAccordionOpen(!accordionOpen)}
                    sx={{
                      textTransform: 'none',
                      px: 0,
                      mb: 1,
                      fontSize: '1rem',
                      fontWeight: 400,
                      color: 'primary.main',
                      '&:hover': {textDecoration: 'underline', backgroundColor: 'transparent'}
                    }}
                  >
                    {accordionOpen ? '' : 'Click here for troubleshooting steps'}
                  </Button>

                  {accordionOpen && (
                    <Box>
                      <Typography variant='body1' gutterBottom>
                        If your claim submission is failing, please try the following troubleshooting steps:
                      </Typography>
                      <ul style={{paddingLeft: '1.25rem', marginTop: '2px'}}>
                        <li>
                          <Typography variant='body1'>Clear your browser cache and cookies.</Typography>
                        </li>
                        <li>
                          <Typography variant='body1'>Ensure your browser is up to date.</Typography>
                        </li>
                        <li>
                          <Typography variant='body1'>Try a different device or browser.</Typography>
                        </li>
                      </ul>
                      <Typography variant='body1' sx={{mt: 1}}>
                        If the issue persists, please contact our support team at:{' '}
                        <a href='https://www.afspa.org/secure-form-member-portal-support' target='_blank' rel='noopener noreferrer'>
                          www.afspa.org/secure-form-member-portal-support
                        </a>
                      </Typography>
                      <Typography variant='body1' sx={{mt: 1}}>
                        We are here to assist you and ensure you can access the resources you need. Thank you for your understanding and cooperation.
                      </Typography>
                    </Box>
                  )}
                </Box>
              </Alert>
            </Box>
          )}
          {showDependentsMissingSsnWarning && dependentsMissingSsnWarning && (
            <Box sx={{width: '100%', py: 1}}>
              <Alert
                severity='warning'
                action={
                  <IconButton aria-label='close' size='small' onClick={() => dispatch(Member.actions.setDependentsMissingSsnWarning(false))}>
                    <CloseIcon fontSize='inherit' />
                  </IconButton>
                }
                sx={{
                  width: '100%',
                  alignItems: 'flex-start',
                  mx: 'auto',
                  maxWidth: '100%',
                  fontSize: '1rem'
                }}
              >
                <Box sx={{width: '100%'}} className='experience-issues-text'>
                  <AlertTitle sx={{fontSize: '1.1rem', fontWeight: 'bold'}}>Update Dependent SSN</AlertTitle>

                  <Typography variant='body1'>
                    A dependent or dependents are missing a Social Security Number (SSN). Please update this information using our secure forms system{' '}
                    <Link component={RouterLink} to='/submit-secureform' state={{requestTypeID: '1003', requestTopic: 'dependent'}} underline='always'>
                      here
                    </Link>{' '}
                    .
                  </Typography>
                </Box>
              </Alert>
            </Box>
          )}
          {showCreditCardIssue && Health && (IBP || Dental || Gel || CI || ADND || Disability || SeniorLife) && (
            <Box sx={{width: '100%', my: 3}}>
              <Alert
                severity='warning'
                sx={{
                  py: 3,
                  px: 3,
                  borderRadius: 2,
                  boxShadow: 2,
                  backgroundColor: '#fff8e1',
                  border: '1px solid #ffe082'
                }}
                action={
                  <IconButton aria-label='close' color='inherit' size='small' onClick={() => setShowCreditCardIssue(false)}>
                    <CloseIcon fontSize='inherit' />
                  </IconButton>
                }
              >
                <Box sx={{width: '100%', maxWidth: 900, mx: 'auto'}}>
                  <Box
                    component='p'
                    sx={{
                      fontSize: '1rem',
                      lineHeight: 1.0,
                      m: 0
                    }}
                  >
                    The Credit/Debit Card payment option is temporarily unavailable until further notice.
                    <br />
                    <br />
                    Please contact the AIP Department at{' '}
                    <a href='mailto:aip@afspa.org' style={{color: '#d32f2f', textDecoration: 'none'}}>
                      aip@afspa.org
                    </a>{' '}
                    or by telephone at{' '}
                    <a href='tel:+12028334910' style={{color: '#d32f2f', textDecoration: 'none'}}>
                      +1 (202) 833-4910
                    </a>{' '}
                    for further assistance.
                    <br />
                    <br />
                    Thank you.
                  </Box>
                </Box>
              </Alert>
            </Box>
          )}

          {/* {Health ? (
            <Alert severity='error' className='claim-text self-stretch'>
              <Link
                to={{
                  pathname: '/submit-claim'
                }}
                state={{
                  claimType: 'mtc'
                }}
              >
                <div className='text-danger' style={{fontSize: 16}}>
                  Are you submitting a Massage Therapy Claim? &nbsp; <span style={{textDecoration: 'underline', textDecorationColor: 'blue', color: 'blue'}}>Click Here</span> to use our new Claim
                  Submission Form.
                </div>
              </Link>
            </Alert>
          ) : null} */}
          {/* {Health ? (
            <Alert severity='info' className='claim-text self-stretch'>
              <div className='text-primary' style={{fontSize: 16}}>
                The 2024 1095-B forms will be available in mid-February. Please check the member portal for updates on availability.
              </div>
            </Alert>
          ) : null} */}
          {bannerdisplay ? (
            <div className='mb-2 bg-light-primary p-8 rounded self-stretch'>
              <div className='mb-5 text-primary'>
                <strong>FSBP One Year Anniversary Survey</strong>
              </div>
              <div className='text-primary'>
                We are so grateful for the opportunity of serving the health care needs of you and your family for the past year. Please take a few minutes and complete the survey below as your
                feedback will help us evaluate our benefits, programs and services.
              </div>
              <div className='d-flex flex-stack flex-wrap gap-3 fs-base fw-semibold'>
                <div />
                <Link
                  to={{
                    pathname: '/submit-secureform'
                  }}
                  state={{
                    requestTypeID: '1049'
                  }}
                >
                  <Button variant='outlined' color='primary' style={{background: '#daeaf5', marginTop: 5}}>
                    Start Survey
                  </Button>
                </Link>
              </div>
            </div>
          ) : null}
          {accreditation ? (
            <div className='mb-5 bg-light-primary p-8 rounded self-stretch'>
              <div className='d-flex justify-between align-center' style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                <div className='text-primary' style={{fontSize: '16px'}}>
                  Notice of Accreditation Survey for the Foreign Service Benefit Plan
                </div>
                <a href='https://www.afspa.org/newsitems/aaahc-accreditation-association-for-ambulatory-health-care-notice-of-public-survey-2/' target='_blank' rel='noreferrer'>
                  <Button variant='outlined' color='primary' style={{background: '#daeaf5', fontSize: '14px'}}>
                    More Information
                  </Button>
                </a>
              </div>
            </div>
          ) : null}
          {/* {splashDisplay && Health && (!(FSBP && FSBP.h_ter_da) || (FSBP && FSBP.h_ter_da && FSBP.h_ter_da.length === 0)) ? (
            <div className='mb-2 self-stretch'>
              <a href='https://forms.office.com/r/mm30TVftrN' target='_blank' rel='noreferrer'>
                <img alt='FSBP Member Survey 2025' src={toAbsoluteUrl('/images/FSBP Member Survey _1_ _004_.png')} width='100%' />
              </a>
            </div>
          ) : null} */}
          {Health ? (
            <PolicyCard title='Foreign Service Benefit Plan (FSBP) Information'>
              <CardInfoDisplay data={FSBP} />
            </PolicyCard>
          ) : null}
          {Health && Dependents && Dependents?.length ? (
            <PolicyCard title='Dependents' cardClassname='bg-white primary-border' titleClassname='text-black pb-3'>
              <DependentsTileGrid dependents={Dependents} />
            </PolicyCard>
          ) : null}
        </React.Fragment>
      </DashboardSection>

      {allowClaims ? (
        <DashboardSection name={'Requests'}>
          <RequestsCard />
        </DashboardSection>
      ) : null}

      {Health ? (
        <DashboardSection name={'Other forms'}>
          <div className='flex flex-col items-start self-stretch'>
            <CardBlueLink text={'Benefits/Claims Questions'} onClick={() => navigate('/submit-secureform', {state: {requestTypeID: '1025'}})} />
            <CardBlueLink text={'FSBP Electronic Funds Transfer Form'} onClick={() => navigate('/submit-secureform', {state: {requestTypeID: '1054'}})} />
            <CardBlueLink text={'Enrollment Information Update (ID Card/Marriage/Birth Certificate, etc.)'} onClick={() => navigate('/submit-secureform', {state: {requestTypeID: '1003'}})} />
            <CardBlueLink
              text={'Find a Doctor'}
              onClick={() => {
                window.open('https://www.aetna.com/dsepublic/#/contentPage?page=providerSearchLanding&site_id=fsbp', '_blank', 'noreferrer')
              }}
            />
            <CardBlueLink
              text={'Meet with HBO in Person (Health Plan)'}
              onClick={() => {
                window.open('https://outlook.office.com/book/AFSPAInPersonMeeting@afspa365.onmicrosoft.com/', '_blank', 'noreferrer')
              }}
            />
            <CardBlueLink
              text={'Meet with AIP/SLF in Person'}
              onClick={() => {
                window.open('https://book.ms/b/AIPInPersonMeeting@afspa365.onmicrosoft.com', '_blank', 'noreferrer')
              }}
            />
          </div>
        </DashboardSection>
      ) : null}

      {IBP || IBPSecondary || Disability || Dental || Gel || CI || ADND || NewLife || Ltc || SeniorLife || SLF ? (
        <DashboardSection name={'My Plans'}>{RenderMyPlans(IBP, IBPSecondary, Disability, Dental, DentalPlanID, Gel, CI, ADND, NewLife, Ltc, SeniorLife, SLF)}</DashboardSection>
      ) : null}

      {Health ? (
        <DashboardSection name={'Downloads'}>
          <div className='flex flex-col items-start self-stretch'>
            {planInformation.map((link) => {
              if (link.planName === 'FSBP') {
                return (
                  <CardBlueLink
                    key={link.id}
                    icon={link.documentIcon}
                    text={link.documentTitle}
                    onClick={() => {
                      window.open(link.documentLink, '_blank', 'noreferrer')
                    }}
                  />
                )
              }
            })}
          </div>
        </DashboardSection>
      ) : null}
    </DashboardBox>
  )
}

export function RenderMyPlans(IBP, IBPSecondary, Disability, Dental, DentalPlanID, Gel, CI, ADND, NewLife, Ltc, SeniorLife, SLF) {
  let navigate = useNavigate()
  return (
    <React.Fragment>
      {IBP ? (
        <PlanCard
          planName='Immediate Benefit Plan'
          planID='IBP'
          balance={IBP ? IBP['Balance Due'] : ''}
          balanceLastUpdated={IBP ? IBP.Modified : ''}
          directDebit={false}
          data={[IBP.Primary]}
          buttons={[
            {
              text: 'Immediate Benefit Plan Question',
              onClick: () => {
                navigate('/submit-secureform', {state: {requestTypeID: '1025'}})
              }
            }
          ]}
          bottomData={IBP ? IBPSecondary : ''}
        />
      ) : null}

      {Disability ? (
        <PlanCard
          planName='Disability Plan'
          planID='Disability'
          balance={Disability ? Disability['Balance Due'] : ''}
          directDebit={false}
          balanceLastUpdated={Disability ? Disability.Modified : ''}
          data={[Disability.Primary && Disability.Primary]}
          buttons={[
            {
              text: 'Disability Plan Question',
              onClick: () => {
                navigate('/submit-secureform', {state: {requestTypeID: '1018'}})
              }
            },
            {
              text: 'Pay via Credit or Debit Card',
              onClick: () => {
                navigate('/makepayment')
              },
              icon: 'credit-card'
            }
          ]}
          bottomData={Disability.Secondary && Disability.Secondary}
        />
      ) : null}

      {Dental ? (
        <PlanCard
          planName='Dental Plan'
          planID={DentalPlanID}
          balance={Dental ? Dental['Balance Due'] : ''}
          balanceLastUpdated={Dental ? Dental.Modified : ''}
          directDebit={Dental.Secondary && Dental.Secondary['Direct Debit'] === 'Active' ? true : false}
          data={[Dental.Primary && Dental.Primary]}
          buttons={[
            {
              text: 'Dental Plan Question',
              onClick: () => {
                navigate('/submit-secureform', {state: {requestTypeID: '2'}})
              }
            },
            // {
            //   text: 'Pay via Credit or Debit Card (Temporarily Unavailable)',
            //   onClick: () => {
            //     navigate('/news')
            //   },
            //   icon: 'credit-card'
            // }
            {
              text: 'Pay via Credit or Debit Card',
              onClick: () => {
                navigate('/makepayment')
              },
              icon: 'credit-card'
            }
          ]}
          bottomData={Dental.Secondary && Dental.Secondary}
        />
      ) : null}

      {Gel ? (
        <PlanCard
          planName='Group Enhanced Life Plan'
          planID='GEL'
          balance={Gel ? Gel['Balance Due'] : ''}
          balanceLastUpdated={Gel ? Gel.Modified : ''}
          directDebit={Gel.Secondary && Gel.Secondary['Direct Debit'] === 'Active' ? true : false}
          data={[Gel.Primary && Gel.Primary]}
          buttons={[
            {
              text: 'Gel Plan Question',
              onClick: () => {
                navigate('/submit-secureform', {state: {requestTypeID: '1015'}})
              }
            },
            // {
            //   text: 'Pay via Credit or Debit Card (Temporarily Unavailable)',
            //   onClick: () => {
            //     navigate('/news')
            //   },
            //   icon: 'credit-card'
            // }
            {
              text: 'Pay via Credit or Debit Card',
              onClick: () => {
                navigate('/makepayment')
              },
              icon: 'credit-card'
            }
          ]}
          bottomData={Gel.Secondary && Gel.Secondary}
        />
      ) : null}

      {SeniorLife ? (
        <PlanCard
          planName='Senior Life Plan'
          planID='SeniorLife'
          balance={SeniorLife ? SeniorLife['Balance Due'] : ''}
          balanceLastUpdated={SeniorLife ? SeniorLife.Modified : ''}
          directDebit={SeniorLife.Secondary && SeniorLife.Secondary['Direct Debit'] === 'Active' ? true : false}
          data={[SeniorLife.Primary && SeniorLife.Primary]}
          buttons={[
            {
              text: 'Senior Life Plan Question',
              onClick: () => {
                navigate('/submit-secureform', {state: {requestTypeID: '1015'}})
              }
            },
            {
              text: 'More Information',
              onClick: () => {
                window.open('https://www.afspa.org/aip/life/#STL1', '_blank', 'noreferrer')
              },
              icon: 'doc'
            },
            // {
            //   text: 'Pay via Credit or Debit Card (Temporarily Unavailable)',
            //   onClick: () => {
            //     navigate('/news')
            //   },
            //   icon: 'credit-card'
            // }
            {
              text: 'Pay via Credit or Debit Card',
              onClick: () => {
                navigate('/makepayment')
              },
              icon: 'credit-card'
            }
          ]}
          bottomData={SeniorLife.Secondary && SeniorLife.Secondary}
        />
      ) : null}

      {Ltc ? (
        <PlanCard
          planName='Long Term Care'
          planID='LTC'
          balance={Ltc ? Ltc['Balance Due'] : ''}
          balanceLastUpdated={Ltc ? Ltc.Modified : ''}
          directDebit={Ltc.Secondary && Ltc.Secondary['Direct Debit'] === 'Active' ? true : false}
          data={[Ltc.Primary && Ltc.Primary]}
          buttons={[
            {
              text: 'Long Term Care Plan Question',
              onClick: () => {
                navigate('/submit-secureform', {state: {requestTypeID: '1015'}})
              }
            },
            {
              text: 'More Information',
              onClick: () => {
                window.open('https://www.afspa.org/aip/life/', '_blank', 'noreferrer')
              },
              icon: 'doc'
            },
            // {
            //   text: 'Pay via Credit or Debit Card (Temporarily Unavailable)',
            //   onClick: () => {
            //     navigate('/news')
            //   },
            //   icon: 'credit-card'
            // }
            {
              text: 'Pay via Credit or Debit Card',
              onClick: () => {
                navigate('/makepayment')
              },
              icon: 'credit-card'
            }
          ]}
          bottomData={Ltc.Secondary && Ltc.Secondary}
        />
      ) : null}

      {NewLife ? (
        <PlanCard
          planName='Group Term Life'
          planID='NewLife'
          balance={NewLife ? NewLife['Balance Due'] : ''}
          balanceLastUpdated={NewLife ? NewLife.Modified : ''}
          directDebit={NewLife.Secondary && NewLife.Secondary['Direct Debit'] === 'Active' ? true : false}
          data={[NewLife.Primary && NewLife.Primary]}
          buttons={[
            {
              text: 'Gel Plan Question',
              onClick: () => {
                navigate('/submit-secureform', {state: {requestTypeID: '1015'}})
              }
            },
            {
              text: 'More Information',
              onClick: () => {
                window.open('https://www.afspa.org/aip/life/', '_blank', 'noreferrer')
              },
              icon: 'doc'
            },
            // {
            //   text: 'Pay via Credit or Debit Card (Temporarily Unavailable)',
            //   onClick: () => {
            //     navigate('/news')
            //   },
            //   icon: 'credit-card'
            // }
            {
              text: 'Pay via Credit or Debit Card',
              onClick: () => {
                navigate('/makepayment')
              },
              icon: 'credit-card'
            }
          ]}
          bottomData={NewLife.Secondary && NewLife.Secondary}
        />
      ) : null}

      {ADND ? (
        <PlanCard
          planName='Accidental Death and Dismemberment Plan'
          planID='ADND'
          balance={ADND ? ADND['Balance Due'] : ''}
          balanceLastUpdated={ADND ? ADND.Modified : ''}
          directDebit={ADND.Secondary && ADND.Secondary['Direct Debit'] === 'Active' ? true : false}
          data={[ADND.Primary && ADND.Primary]}
          buttons={[
            {
              text: 'Accidental Death and Dismemberment Plan Question',
              onClick: () => {
                navigate('/submit-secureform', {state: {requestTypeID: '1015'}})
              }
            },
            // {
            //   text: 'Pay via Credit or Debit Card (Temporarily Unavailable)',
            //   onClick: () => {
            //     navigate('/news')
            //   },
            //   icon: 'credit-card'
            // }
            {
              text: 'Pay via Credit or Debit Card',
              onClick: () => {
                navigate('/makepayment')
              },
              icon: 'credit-card'
            }
          ]}
          bottomData={ADND.Secondary && ADND.Secondary}
        />
      ) : null}

      {CI ? (
        <PlanCard
          planName='Critical Illness Plan'
          planID='CI'
          balance={CI ? CI['Balance Due'] : ''}
          balanceLastUpdated={CI ? CI.Modified : ''}
          directDebit={CI.Secondary && CI.Secondary['Direct Debit'] === 'Active' ? true : false}
          data={[CI.Primary && CI.Primary]}
          buttons={[
            {
              text: 'Critical Illness Plan Question',
              onClick: () => {
                navigate('/submit-secureform', {state: {requestTypeID: '1015'}})
              }
            },
            // {
            //   text: 'Pay via Credit or Debit Card (Temporarily Unavailable)',
            //   onClick: () => {
            //     navigate('/news')
            //   },
            //   icon: 'credit-card'
            // }
            {
              text: 'Pay via Credit or Debit Card',
              onClick: () => {
                navigate('/makepayment')
              },
              icon: 'credit-card'
            }
          ]}
          bottomData={CI.Secondary && CI.Secondary}
        />
      ) : null}

      {SLF && SLF.length > 0 ? <DonationPreviewCard donations={SLF} /> : null}
    </React.Fragment>
  )
}
